import React from 'react';
import { Box, Flex } from 'rebass';
import { UtilityIconButton } from '../Button/UtilityIconButton';

export interface ThirdPanePaginationProps {
  onPrev?: () => void;
  onNext?: () => void;
  prevEnabled?: boolean;
  nextEnabled?: boolean;
}

const ThirdPanePagination = (props: ThirdPanePaginationProps): JSX.Element => {
  return (
    <Flex sx={{ gap: 2, flexShrink: 0 }}>
      {props.onPrev && (
        <UtilityIconButton
          disabled={props.prevEnabled === false}
          onClick={props.onPrev}
          icon="chevron-left"
          dark
        />
      )}
      {props.onNext && (
        <UtilityIconButton
          disabled={props.nextEnabled === false}
          onClick={props.onNext}
          icon="chevron-right"
          dark
        />
      )}
    </Flex>
  );
};

export default ThirdPanePagination;
